import { useMemo } from 'react';

import { CareerPath } from '@backrs_ui/common-ui';

export const useCareerPathById = (careerPathId: string | undefined, careerPaths: CareerPath[]) => {
  return useMemo(() => {
    if (!careerPathId) return null;

    const pathId = parseInt(careerPathId);

    if (isNaN(pathId)) return null;

    return careerPaths.find((path) => path.id === pathId) || null;
  }, [careerPathId, careerPaths]);
};
